import React from 'react';
import styled from 'react-emotion';

const LightIconDiv = styled.div`
  z-index: 999;
  position: absolute;
  top: -46px;
  right: -32px;
  font-size: 68px;

  opacity: 0.0;
  transition: opacity 0.4s;
`;

const LightIcon = () => {
  return(
    <LightIconDiv id="LightIcon">
        <svg
            preserveAspectRatio="xMidYMid meet"
            height="1em"
            width="1em"
            viewBox="0 0 576 576"
            style={{ verticalAlign: "middle", marginRight: "0.5rem"}}>
              <g style={{ stroke: "black",
                    fill: "`${props => props.theme.colors.warm.base}",
                    strokeWidth: "26px"}}>
              <path d="m364.78 96.281l-22.906 117.44c5.9091-0.8949 11.966-1.3438 18.125-1.3438 8.3953 0 16.591 0.85947 24.5 2.5l-19.719-118.59zm-87.062 15.031l21.031 117.84c12.096-7.1948 25.552-12.299 39.906-14.875l-60.938-102.97zm173.69 2.4375l-64.125 101.72c14.293 3.3233 27.612 9.2006 39.438 17.125l24.688-118.84zm-249.44 43.031l62.562 102.88c8.6832-11.384 19.356-21.146 31.5-28.812l-94.062-74.062zm323.88 4.5312l-97.5 72.406c11.995 8.3266 22.392 18.802 30.656 30.844l66.844-103.25zm-164.16 64.906c-1.0487-0.0078-2.1059 0.00471-3.1562 0.03125-55.597-0.58048-106.32 50.171-104.66 106-0.4019 47.203 34.268 93.11 80.875 103.19 42.281 10.45 90.54-7.3766 113.78-44.594 24.159-36.188 23.554-87.289-3.4375-121.75-19.366-26.001-50.896-42.633-83.406-42.875zm-213.97 0.3125l96.531 74.094c3.8728-14.16 10.273-27.257 18.688-38.812l-115.22-35.281zm430.38 6.0312l-118.59 32.719c12.939 19.152 20.5 42.241 20.5 67.094 0 66.274-53.726 120-120 120-61.502 0-112.17-46.28-119.16-105.91l-111.56 52.781 123.78-10.469-85.5 90.125 111.62-54.5-47.188 114.94 84.438-91.156-2.5 124.22 45.812-115.5 42.531 116.72 1-124.22 81.844 93.469-43.969-116.22 110.06 57.594-82.969-92.469 123.47 13.938-110.78-56.25 120.16-31.594-123.59-12.469 100.59-72.844zm-334.31 69.812l-121.41 8.7812 118.41 34.719c-0.49736-4.4369-0.78125-8.9303-0.78125-13.5 0-10.355 1.315-20.414 3.7812-30z" />
            </g>
          </svg>
    </LightIconDiv>
  );
};

export default LightIcon;




// WEBPACK FOOTER //
// ./src/icons/solid/LightIcon.jsx